import { API_ROOT } from '@config/api';
import request from '@common/utils/request';

const doVerify = (data) => (dispatch) =>
	request('post', `${API_ROOT}/users/verify`, data)
		.then((response) => Promise.resolve(response))
		.catch((err) => Promise.reject(err));

export { doVerify };
